import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components/macro';
import { compose } from 'redux';
import { connect } from 'react-redux';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupFull
} from '../../containers/DefaultStyles/FormDetails';

import Button from '../Button';
import TwoGroup from '../TwoGroup';
import CheckboxGroup from '../CheckboxGroup';
import DropDownSelect from '../DropDownSelect';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { styledScrollbar } from '../Shared/mixins';

import { defaultSize, isPortrait } from '../../utils/size';
import { ThemeConsumer } from '../../utils/theming';
import { validateStep8 } from './validations';

const InfoText = styled.span`
    font-size: 12px;
    margin: 0 8px;
    ${() => isPortrait() && `margin-top: 0.5em`};
`;

const FormContainer = styled(Container)`
    ${() => isPortrait() && `height: 98%`};
`;

const ScrollContainer = styled.div`
    overflow-x: hidden;
    overflow-y: scroll;
    height: 85%;

    ${({ theme }) => !isPortrait() && styledScrollbar(theme.colors.primary)};
`;
class VoteRegistrationStep8Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = { class: 'default', isFormScrollable: false };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.setState({ class: 'changed' });
    }

    componentDidMount() {
        this.setScrollableState();
        window.onresize(() => this.setScrollableState());
    }

    setScrollableState() {
        if (
            document.getElementById('formContainer').scrollHeight + 45 >
            (isPortrait() ? defaultSize.heightPortrait : defaultSize.height)
        ) {
            this.setState({ isFormScrollable: true });
        }
    }

    render() {
        return (
            <ThemeConsumer>
                {theme => (
                    <FormContainer
                        id="formContainer"
                        autocomplete="on"
                        onSubmit={this.props.handleSubmit}
                    >
                        <ScrollContainer theme={theme}>
                            <MultipleGroupFull style={{ flexDirection: `column` }}>
                                <InfoText>{this.props.infoTextRace}</InfoText>
                                <Field
                                    name={
                                        this.props.infoTextRaceRequired
                                            ? 'race'
                                            : 'raceNotRequired'
                                    }
                                    component={DropDownSelect}
                                    options={this.props.races}
                                    defaultOption="Choose"
                                    label="Race"
                                    type="text"
                                    onChange={this.handleChange}
                                    class={this.state.class}
                                />
                            </MultipleGroupFull>
                            <MultipleGroupFull style={{ flexDirection: `column` }}>
                                <InfoText>{this.props.infoTextParty}</InfoText>
                                <Field
                                    name={
                                        this.props.infoTextPartyRequired
                                            ? 'party'
                                            : 'partyNotRequired'
                                    }
                                    component={DropDownSelect}
                                    options={this.props.parties}
                                    defaultOption="Choose"
                                    label="Party"
                                    type="text"
                                />
                            </MultipleGroupFull>
                            <MultipleGroupFull>
                                <Field
                                    name="partnerOptInVolunteer"
                                    component={CheckboxGroup}
                                    label="Want to opt in to volunteer with Rock the Vote?"
                                    normalize={v => !!v}
                                />
                            </MultipleGroupFull>
                        </ScrollContainer>
                        <ButtonGroupWrapper
                            isFormSubmitting={this.props.isFormSubmitting}
                            rightPosition={23}
                        >
                            <TwoGroup>
                                <Button label="Back" onClick={this.props.onBack} />
                                <Button
                                    primary={true}
                                    type="submit"
                                    label="Prepare Form"
                                    className="submitButton"
                                    disabled={this.props.invalid}
                                    isSubmitting={this.props.isFormSubmitting}
                                />
                                <LoadingSpinner />
                            </TwoGroup>
                        </ButtonGroupWrapper>
                    </FormContainer>
                )}
            </ThemeConsumer>
        );
    }
}

VoteRegistrationStep8Form.propTypes = {
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
    infoTextRace: PropTypes.string,
    infoTextRaceRequired: PropTypes.bool,
    infoTextParty: PropTypes.string,
    infoTextPartyRequired: PropTypes.bool,
    parties: PropTypes.array,
    races: PropTypes.array,
    isFormSubmitting: PropTypes.bool
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'voteRegistrationStep8Form',
        validate: validateStep8,
        destroyOnUnmount: false
    })
)(VoteRegistrationStep8Form);
